import { Component, OnInit } from '@angular/core';
import { IApplicationResponse, ModulesBasedApiSuffix, RxjsService, SharedModuleApiSuffixModels } from '@app/shared';
import { CrudService } from '@app/shared/services/crud.service';
// import { ModulesBasedApiSuffix, SharedModuleApiSuffixModels } from '@app/shared/utils/enums.utils';
// import { IApplicationResponse } from '@app/shared/utils/interfaces.utils';
// import { CrudService, RxjsService,ModulesBasedApiSuffix, SharedModuleApiSuffixModels } from '@app/shared';
import { FormControl, FormGroup, Validators } from '@angular/forms';
@Component({
    selector: 'app-version-details',
    templateUrl: './version-details.component.html',
    styleUrls: ['./version-details.component.scss']
  })

  export class VersionDetailsComponent implements OnInit {
    myForm: FormGroup;
    versionsList: any;
    versionDetails: any;
    constructor(private crudService: CrudService, private rxjsService: RxjsService) {
        
    }

    ngOnInit(): void {
        this.createVersionForm();
        this.getVersionList();
        this.formControlChanges();
    }

    createVersionForm() {
        this.myForm = new FormGroup({
            version: new FormControl('')
          });
    }

    getVersionList() {
        this.crudService.get(ModulesBasedApiSuffix.SHARED,
            SharedModuleApiSuffixModels.VERSIONS)
            .subscribe((response: IApplicationResponse) => {
                console.log('version response', response);
              if (response.isSuccess && response.statusCode == 200 && response.resources.length > 0) {
                this.versionsList = response?.resources;
                this.myForm.get('version').setValue(this.versionsList[0].id);

              }

              this.rxjsService.setGlobalLoaderProperty(false)
            });
        
    }

    formControlChanges() {
        this.myForm.get('version').valueChanges.subscribe(value => {
            console.log('First Name value changed:', value);
            if(value){
                this.getVersionDetails(value);
            }
          });
      
    }

    getVersionDetails(value?: string) {
        console.log('findVersionDetails', this.versionsList);
        if (this.myForm.invalid) {
            console.log('Form Error:', this.myForm.value);
            return

        } else {
            let reqVersionId = value ? value : this.myForm.value.version;
            console.log('findVersionDetails', reqVersionId);
            this.crudService.get(ModulesBasedApiSuffix.SHARED,
                SharedModuleApiSuffixModels.VERSION, reqVersionId)
                .subscribe((response: IApplicationResponse) => {
                    console.log('version response', response);
                  if (response.isSuccess && response.statusCode == 200 && response?.resources) {
                     this.versionDetails = response?.resources;
                  }
                  this.rxjsService.setGlobalLoaderProperty(false)
                });

        }
        
    }

  }
  